import { Component } from '@angular/core';
import { iBisBaseComponent } from '@dohu/ibis-common';
import { ProxyService } from '../../../../service/proxy.service';
import { CancelAppointmentService } from './cancel-appointment.service';

@Component({
    selector: 'app-cancel-appointment',
    templateUrl: './cancel-appointment.component.html'
})
export class CancelAppointmentComponent extends iBisBaseComponent {

    public declare edit: CancelAppointmentService;
    constructor(public proxy: ProxyService) {
        super(proxy.cancelAppointment, proxy.lg, proxy.iui, proxy.activatedRoute);
    }
}
